export default "__VITE_ASSET__kGYro0s6__"